export default __webpack_public_path__ + "static/media/officiants.76fb73ef.jpg";